import {List, Map} from 'immutable';
import {zip} from 'rxjs';
import {flatMap} from 'rxjs/operators';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import EmployeeModel from 'web-app/react/entities/employees/model';
import ChildModel from 'web-app/react/entities/children/model';

import * as Models from './models';

export const fetchInstitutionDepartments = (institutionId: string) =>
    RESTClient.getAuthenticatedObservable('daycare/department/list', {
        institutionId,
    }).map((response: {departments: any[]}) =>
        response.departments.reduce(
            (reduction, department) => reduction.set(department.departmentId, department),
            Map(),
        ),
    );

/**
 * @deprecated use the useStatSettings().openingHours  instead
 */
export const fetchInstitutionOpeningHours = (institutionId: string) =>
    RESTClient.getAuthenticatedObservable(`v2/institutions/${institutionId}/openinghours`, {}).map(
        (response: Models.BaseOpeningHour[]) => List(response).map(Models.openingHourFromApi),
    );

export const fetchTabs = (institutionId: string) =>
    RESTClient.getAuthenticatedObservable(`v2/institutions/${institutionId}/tabs`, {}).map(
        (response: Models.TabFromApi[]) => {
            const responseList = List(response);
            const starTab = responseList.find(tab => tab.id === 'STAR');
            return {
                hasStarredGroups: Boolean(starTab && starTab.groupsCount > 0),
                tabs: responseList.map(Models.convertTabFromApi),
            };
        },
    );

const fetchChildBirthdays = (institutionId: string) =>
    RESTClient.getAuthenticatedObservable('v2/children/birthday', {institutionId}).map(response => List(response));

const fetchEmployeeBirthdays = (institutionId: string) =>
    RESTClient.getAuthenticatedObservable('v2/employees/birthday', {institutionId}).map(response => List(response));

export const fetchBirthdays = (institutionId: string) =>
    zip(fetchChildBirthdays(institutionId), fetchEmployeeBirthdays(institutionId)).pipe(
        flatMap(([childBirthdays, employeeBirthdays]) => [
            new Models.Birthdays({
                children: List(childBirthdays).map(ChildModel.fromAPI),
                employees: List(employeeBirthdays).map(EmployeeModel.fromAPI),
            }),
        ]),
    );
